function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { connect } from 'react-redux';

import { config } from './../../../conf/config';

import * as chatroomActions from './../chatroomActions';

export var ImageForm = function (_Component) {
    _inherits(ImageForm, _Component);

    function ImageForm(props) {
        _classCallCheck(this, ImageForm);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleClick = function () {
            var dispatch = _this.props.dispatch;

            dispatch(chatroomActions.showNotEnabledPopup());
        };

        _this.handleChange = function (e) {
            var _this$setState;

            var _e$target = e.target,
                name = _e$target.name,
                value = _e$target.value;
            var dispatch = _this.props.dispatch;

            _this.setState((_this$setState = {}, _this$setState[name] = value, _this$setState));

            e.preventDefault();

            if (e.target.files[0]) {
                dispatch(chatroomActions.sendPreview(e.target.files[0]));
            }
        };

        _this.state = {
            photo: '',
            imagePreviewUrl: ''
        };

        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }

    ImageForm.prototype.render = function render() {

        var cameraButton = React.createElement(
            'div',
            null,
            React.createElement(
                'label',
                { htmlFor: 'file' },
                React.createElement('div', { className: 'camera-button' })
            ),
            React.createElement('input', { className: 'hide',
                id: 'file',
                type: 'file',
                accept: 'image/*',
                capture: 'camera',
                name: 'photo',
                onChange: this.handleChange })
        );

        if (!config.isPhotoEnabled) {
            cameraButton = React.createElement(
                'div',
                null,
                React.createElement('div', { onClick: this.handleClick, className: 'camera-button' })
            );
        }

        return React.createElement(
            'div',
            { className: 'previewButton' },
            cameraButton
        );
    };

    return ImageForm;
}(Component);

export default connect(null)(ImageForm);


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-chat/es/components/Chatroom/ImageForm/ImageForm.js
// module id = 222
// module chunks = 0